import styled from 'styled-components';

export const CollectionDetails = styled.div`
  & > *:last-child {
    margin-top: 30px;
  }
`;
